import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#25252D",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m4.741 15.371 1.253.197c.925.144 1.585.991 1.517 1.945l-.092 1.294a.92.92 0 0 0 .506.895l.926.457a.885.885 0 0 0 1.001-.153l.931-.88a1.763 1.763 0 0 1 2.433 0l.93.88a.88.88 0 0 0 1.002.153l.928-.458a.92.92 0 0 0 .505-.893l-.093-1.295c-.068-.954.592-1.8 1.517-1.946l1.253-.196a.91.91 0 0 0 .74-.705l.23-1.024a.93.93 0 0 0-.369-.964l-1.046-.732a1.86 1.86 0 0 1-.54-2.426l.63-1.124a.94.94 0 0 0-.076-1.032l-.64-.822a.89.89 0 0 0-.968-.306l-1.211.38c-.895.28-1.85-.19-2.194-1.08l-.464-1.204a.9.9 0 0 0-.838-.582l-1.027.003a.9.9 0 0 0-.836.586l-.453 1.19C9.856 6.425 8.897 6.9 8 6.616L6.738 6.22a.89.89 0 0 0-.97.308l-.636.823a.94.94 0 0 0-.07 1.036l.645 1.126a1.86 1.86 0 0 1-.533 2.44l-1.033.725a.93.93 0 0 0-.368.963L4 14.666c.082.369.376.649.74.705"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#25252D",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M13.945 10.055a2.75 2.75 0 1 1-3.89 3.89 2.75 2.75 0 0 1 3.89-3.89"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }